<div class="deals-area pb-3 pt-3 sticky-header mb-2" [ngStyle]="{'background-color': dealBackgroundColor}">
  <div class="cover-hero" *ngIf="coverUrlBust" [style.background-image]="'url(' + coverUrlBust + ')'"
    aria-label="Pet store cover photo">
  </div>
  <!-- <div>
    <div> -->

  <div class="container">

    <!-- <div class="row toolbar-row button">
            <div class="col-12 button-end">
                <button *ngIf="currentTab === 'featured' && campaignList?.length > 0" type="button"
                    class="btn btn-deals w-40" (click)="switchTab('promotions')">
                    Promotions  <i class="fa-solid fa-arrow-right ms-1"></i>
                </button>
                <button *ngIf="currentTab === 'promotions' && featuredList?.length > 0" type="button"
                    class="btn btn-deals w-40" (click)="switchTab('featured')">
                   <i class="fa-solid fa-arrow-left me-1">  </i>Featured List
                </button>
            </div>
        </div> -->


    <div class="share-dialog-content socialShare social-left" *ngIf="hasAnyShare">
      <div class="social-label">Share</div>

      <ul class="social">
        <li *ngIf="social.facebook">
          <a [href]="social.facebook" target="_blank" class="facebook" matTooltipPosition="below"
            matTooltipShowDelay="0" matTooltip="Facebook">
            <i class="bx bxl-facebook"></i>
          </a>
        </li>

        <li *ngIf="social.linkedin">
          <a [href]="social.linkedin" target="_blank" class="linkedin" matTooltipPosition="below"
            matTooltipShowDelay="0" matTooltip="LinkedIn">
            <i class="bx bxl-linkedin"></i>
          </a>
        </li>

        <li *ngIf="social.twitter">
          <a [href]="social.twitter" target="_blank" class="twitter" matTooltipPosition="below" matTooltipShowDelay="0"
            matTooltip="Twitter">
            <i class="bx bxl-twitter"></i>
          </a>
        </li>

        <li *ngIf="social.tiktok">
          <a [href]="social.tiktok" target="_blank" class="tiktok" matTooltipPosition="below" matTooltipShowDelay="0"
            matTooltip="TikTok">
            <i class="bx bxl-tiktok"></i>
          </a>
        </li>

        <li *ngIf="social.youtube">
          <a [href]="social.youtube" target="_blank" class="youtube" matTooltipPosition="below" matTooltipShowDelay="0"
            matTooltip="YouTube">
            <i class="bx bxl-youtube"></i>
          </a>
        </li>

        <li *ngIf="social.instagram">
          <a [href]="social.instagram" target="_blank" class="instagram" matTooltipPosition="below"
            matTooltipShowDelay="0" matTooltip="Instagram">
            <i class="bx bxl-instagram"></i>
          </a>
        </li>

        <li *ngIf="social.pinterest">
          <a [href]="social.pinterest" target="_blank" class="pinterest" matTooltipPosition="below"
            matTooltipShowDelay="0" matTooltip="Pinterest">
            <i class="bx bxl-pinterest"></i>
          </a>
        </li>
      </ul>
    </div>

    <div class="share-dialog-content socialShare social-right" *ngIf="hasAnyShare">
      <div class="social-label">Follow Us</div>

      <ul class="social">
        <li *ngIf="whatsappURL">
          <a [href]="whatsappURL" class="wp-image wpImg text-center" target="_blank" matTooltip="WhatsApp">
            <!-- <img [src]="wpImage" class="wp-img" /> -->
            <img [src]="wpImage" matTooltip="Click to chat" class="wp-img" alt="WhatsApp" matTooltipPosition="below"
              matTooltipShowDelay="0">
          </a>
        </li>

        <li *ngIf="smsUrl && isMobileView">
          <a [href]="smsUrl" class="wp-image text-center" target="_blank" matTooltip="SMS">
            <!-- <img src="assets/img/sms3.png" /> -->
            <img src="assets/img/sms3.png" matTooltip=" Click to Text" class="wp-img" alt="SMS"
              matTooltipPosition="below" matTooltipShowDelay="0">
          </a>
        </li>

        <li *ngIf="hasVcard">
          <button (click)="downloadVcard()" class="vcard-small" matTooltip="Add to Contact">
            <!-- <img [src]="vcard" /> -->
            <img [src]="vcard" class="vcard-small" alt="vCard" matTooltipPosition="below" matTooltipShowDelay="0">
          </button>
        </li>

        <li *ngIf="social.amazon">
          <a [href]="social.amazon" target="_blank" matTooltipPosition="below" matTooltipShowDelay="0"
            matTooltip="Amazon">
            <img src="assets/icons/amazon.png" class="amazon" />
          </a>
        </li>

        <li *ngIf="social.flipkart">
          <a [href]="social.flipkart" target="_blank" matTooltipPosition="below" matTooltipShowDelay="0"
            matTooltip="Flipkart">
            <img src="assets/icons/flipkart.png" class="flipkart" />
          </a>
        </li>

        <li *ngIf="social.buyonline">
          <a [href]="social.buyonline" target="_blank" matTooltipPosition="below" matTooltipShowDelay="0"
            matTooltip="Company Website">
            <i class="bx bx-globe"></i>
          </a>
        </li>
      </ul>
    </div>

    <!-- <button *ngIf="showUpi" class="share-line-item upi-btn-small" (click)="openUpi()">
          <span class="upi-text"><b>Pay via</b></span>
          <img [src]="upiImg" matTooltip="Want to make Payment?" class="upi-small-img" alt="UPI">
        </button> -->
    <!-- <button class="copy"
          (click)="onCopyClick($event, productOrRow)">
    <i class="bx bx-copy-alt"></i>
  </button> -->
    <!-- 
    <div class="share-dialog-content socialShare" *ngIf="hasAnyShare">
      <div class="top-share-line">

        <a *ngIf="whatsappURL" [href]="whatsappURL" target="_blank" class="wp-image wpImg text-center">
          <img [src]="wpImage" matTooltip="Click to chat" class="wp-img" alt="WhatsApp" matTooltipPosition="below"
        matTooltipShowDelay="0" >
        </a>

        <a *ngIf="smsUrl" [href]="smsUrl" target="_blank" class="wp-image text-center">
          <img src="assets/img/sms3.png" matTooltip=" Click to Text" class="wp-img" alt="SMS" matTooltipPosition="below"
         matTooltipShowDelay="0" >
       </a>

        <button *ngIf="hasVcard" class="share-line-item vcard-only-btn wp-image text-center" (click)="downloadVcard()">
          <img [src]="vcard" matTooltip="Add to Contact" class="vcard-small" alt="vCard" matTooltipPosition="below"
        matTooltipShowDelay="0" >
        </button>

    

        <ul class="social">
          <li>
            <a *ngIf="social.website" [href]="social.website" matTooltip="Web site" target="_blank" matTooltipPosition="below"
           matTooltipShowDelay="0" >
              <i class="bx bx-globe"></i>
            </a>
          </li>

          <li>
            <a *ngIf="social.facebook" [href]="social.facebook" target="_blank" matTooltip="Facebook" class="facebook" matTooltipPosition="below"
           matTooltipShowDelay="0" >
              <i class="bx bxl-facebook"></i>
            </a>
          </li>

          <li>
            <a *ngIf="social.instagram" [href]="social.instagram" matTooltip="Instagram" target="_blank"
              class="instagram" matTooltipPosition="below" matTooltipShowDelay="0" >
              <i class="bx bxl-instagram"></i>
            </a>
          </li>

          <li>
            <a *ngIf="social.twitter" [href]="social.twitter" target="_blank" matTooltip="Twitter" class="twitter" matTooltipPosition="below"
             matTooltipShowDelay="0" >
              <i class="bx bxl-twitter"></i>
            </a>
          </li>

          <li>
            <a *ngIf="social.linkedin" [href]="social.linkedin" target="_blank" matTooltip="Linkedin" class="linkedin" vmatTooltipPosition="below"
            matTooltipShowDelay="0">
              <i class="bx bxl-linkedin"></i>
            </a>
          </li>
          <li *ngIf="social.tiktok">
            <a [href]="social.tiktok" class="tiktok" matTooltip="Tiktok" target="_blank" rel="noopener"><i
                class="bx bxl-tiktok" matTooltipPosition="below"
             matTooltipShowDelay="0" ></i></a>
          </li>
          <li *ngIf="social.pinterest">
            <a [href]="social.pinterest" class="pinterest" matTooltip="Pinterest" target="_blank" rel="noopener" matTooltipPosition="below"
           matTooltipShowDelay="0" ><i
                class="bx bxl-pinterest"></i></a>
          </li>
          <li>
            <a *ngIf="social.amazon" [href]="social.amazon" target="_blank" matTooltip="Amazon"  matTooltipPosition="below"
             matTooltipShowDelay="0" >
              <img src="assets/icons/amazon.png" class="amazon" alt="Amazon" width="32">
            </a>
          </li>

          <li>
            <a *ngIf="social.flipkart" [href]="social.flipkart" target="_blank" matTooltip="Flipkart" matTooltipPosition="below"
             matTooltipShowDelay="0" >
               <img src="assets/icons/flipkart.png"  class="flipkart" alt="Flipkart" width="32">
            </a>
          </li>

          <li>
            <a *ngIf="social.buyonline" [href]="social.buyonline" target="_blank" matTooltip="Buy Online"
              class="instagram" matTooltipPosition="below"
              matTooltipShowDelay="0" >
              <i class="bx bx-shopping-bag"></i>
            </a>
          </li>

          <li *ngIf="social.youtube">
            <a [href]="social.youtube" class="youtube" matTooltip="Youtube" target="_blank" rel="noopener" matTooltipPosition="below"
            matTooltipShowDelay="0" >
              <i class="bx bxl-youtube"></i>
            </a>
          </li>

    

          <li>
            <a href="#" title="copy" class="copy" matTooltip="Copy Link" target="_blank" rel="noopener" matTooltipPosition="below"
            matTooltipShowDelay="0" 
              (click)="onCopyClick($event, productOrRow)">
              <i class="bx bx-copy-alt"></i>
            </a>
          </li>


          <li (click)="openShareDialog(shareDialog, $event)"><a title="share" matTooltip="Share Link"
              class="share" matTooltipPosition="below" matTooltipShowDelay="0" ><img src="assets/img/shareIcon.png" alt="shareImage" class="icon" /></a></li>
        </ul>
      </div>

      <ng-template #shareDialog>
        <div class="share-dialog-content">
          <a target="_blank" rel="noopener" class="facebook-icon" (click)="shareOnFacebook(item)">
            <i class="fab fa-facebook"></i>
          </a>
          <a class="instagram-icon" (click)="shareOnInstagram(item)">
            <i class="fab fa-instagram"></i>
          </a>
          <a class="twitter-icon" (click)="shareOnTwitter(item)"> <i class="bx bxl-twitter"></i></a>
          <a class="linkedin-icon" (click)="shareOnLinkedIn(item)"><i class="bx bxl-linkedin"></i></a>
        </div>
      </ng-template>
    </div> -->

    <div class="row gx-3 gy-4  feature-list-row equal-row">

      <!-- <ng-container *ngIf="featuredList?.length > 0"> -->
      <ng-container *ngIf="featuredList?.length > 0">
        <div class="col-md-3 col-sm-6 featured-col" *ngFor="let item of featuredList">

          <div class="card featured-card equal-card">

            <!-- Make image area clickable -->
            <div class="featured-image-click" (click)="onClickViewDetail(item.productId || item._id)" role="button">
              <!-- 
    <owl-carousel-o [options]="dealsDetailsImageSlides">
      <ng-template carouselSlide *ngFor="let img of item.productImages">
        <img class="mt-3"
             [src]="img?.src"
             (error)="onImgErr($event)" />
      </ng-template>
    </owl-carousel-o> -->
              <owl-carousel-o *ngIf="item.productImages?.length; else noImg" [options]="dealsDetailsImageSlides">

                <ng-template carouselSlide *ngFor="let img of item.productImages">
                  <img class="mt-3" [src]="img?.src" (error)="onImgErr($event)" />
                </ng-template>

              </owl-carousel-o>

              <ng-template #noImg>
                <img src="assets/img/no-image.png" class="mt-3" />
              </ng-template>
            </div>

            <div class="card-body mt-5 bt-fix d-flex flex-column text-center justify-content-end">
              <h5 class="card-title mt-auto text-truncate">
                {{ item.name }}
              </h5>

              <div class="row justify-content-center p-0 m-0 pt-1 pb-1 featured-action-row">
                <!-- (click)="onClickViewDetail(item.productId)" -->
                <button type="button" class="col-lg-8 col-md-8 col-sm-12 mx-1 mb-2 default-custom-btn"
                  (click)="onClickViewDetail(item.productId || item._id)">
                  View
                </button>

                <button type="button" *ngIf="item.isCartItem && item?.attributeIds?.length == 0"
                  class="col-lg-3 col-md-3 col-sm-3 col-3 mb-2"
                  [ngClass]="item.isWishList ? 'default-custom-lock-btn' : 'default-custom-btn'"
                  (click)="onClickWishList(item)">
                  <i class="bx bxs-cart-add"></i>
                </button>
              </div>
            </div>

            <span class="variant-count" *ngIf="storeId && item.type == 'Product Group'">
              *{{ item.count }} variants available
            </span>

          </div>

          <!-- <div class="card featured-card equal-card">

            <owl-carousel-o [options]="dealsDetailsImageSlides">
              <ng-template carouselSlide *ngFor="let img of item.productImages">
                <img class="mt-3" [src]="img?.src" (error)="onImgErr($event)" />
              </ng-template>
            </owl-carousel-o>

            <div class="card-body  mt-5 bt-fix d-flex flex-column text-center justify-content-end">
              <h5 class="card-title mt-auto text-truncate">
                {{ item.name }}
              </h5>

              <div class="row justify-content-center p-0 m-0 pt-1 pb-1 featured-action-row">
                <button type="button" class="col-lg-8 col-md-8 col-sm-12 mx-1 mb-2 default-custom-btn"
                  (click)="onClickViewDetail(item.productId)">
                  View
                </button>

                <button type="button" class="col-lg-3 col-md-3 col-sm-3 col-3 mb-2" *ngIf="item.isCartItem"
                  [ngClass]="item.isWishList ? 'default-custom-lock-btn' : 'default-custom-btn'"
                  (click)="onClickWishListfeatured(item)">
                  <i class="bx bxs-cart-add"></i>
                </button>
              </div>
            </div>
            <span class="variant-count" *ngIf="storeId && item.type == 'Product Group'">*{{item.count}} variants available</span>
          </div> -->
        </div>
      </ng-container>


      <!-- <ng-container *ngIf="campaignList?.length > 0"> -->
      <!-- <ng-template #campaignsBlock> -->
      <ng-container *ngIf="campaignList?.length > 0">
        <div class="col-xl-3 col-lg-6 col-md-6 col-sm-6 deal-container equal-col mb-4 dealContainer"
          *ngFor="let Content of campaignList | paginate:{ itemsPerPage: pageSize, currentPage: pageIndex, totalItems: totalRows }">

          <!-- <div class="col-md-3 col-sm-6 featured-col deal-container equal-col mb-4 dealContainer"
     *ngFor="let Content of campaignList | paginate:{ itemsPerPage: pageSize, currentPage: pageIndex, totalItems: totalRows }"> -->

          <div class="ribbon-wrapper sparkle-ribbon" (click)="triggerSparkle($event)">
            <img src="assets/img/onOffer1.png" class="card-overlay-image" />
            <span class="star s1"></span>
            <span class="star s2"></span>
            <span class="star s3"></span>
            <span class="star s4"></span>
            <span class="star s5"></span>
            <span class="star s6"></span>
            <span class="star s7"></span>
            <span class="star s8"></span>
          </div>

          <div class="single-deals-box equal-card promotion-card equal-card">

            <owl-carousel-o [options]="dealsDetailsImageSlides">
              <ng-template carouselSlide *ngFor="let product of getVisibleProducts(Content.products)">
                <div class="deals-image mt-3">
                  <a href="javascript:void(0)" (click)="onClickDetail(Content)">
                    <img [src]="product.image_url ?? 'assets/img/no-image.png'" alt="image">
                  </a>
                </div>
              </ng-template>
            </owl-carousel-o>

            <div class="owl-dots-placeholder" *ngIf="(Content.products?.length || 0) <= 1"></div>

            <div class="deals-content pt-2">
              <h3 class="text-center m-0">{{ Content.campaignHeading }}</h3>
              <h3 class="text-center m-0">
                <a href="javascript:void(0)" class="ellipsis">{{ Content.campaignName }}</a>
              </h3>
              <p class="text-center m-0 ellipsis-description" style="height: 1.8em;width: 100%">
                {{ Content.offerDescription }}
              </p>

              <div class="row feature-list-row justify-content-center p-0 m-0 pt-1 pb-1">
                <button type="button" class="col-lg-8 col-md-8 col-sm-12 mx-1 mb-2 default-custom-btn"
                  (click)="onClickDetail(Content)">
                  View
                </button>

                <!-- <button type="button"
                  class="col-lg-8 col-md-8 col-sm-12 mx-1 mb-2 default-custom-btn"
                  (click)="onClickClaimNow(Content)">
            View
          </button> -->


                <button type="button" *ngIf="Content.isCartItem"
                  [ngClass]="Content.isWishList ? 'col-lg-3 col-md-3 col-sm-3 col-3 default-custom-lock-btn' : 'col-lg-3 col-md-3 col-sm-3 col-3 default-custom-btn'"
                  (click)="onClickWishList(Content)" class="mb-2">
                  <i class='bx bxs-cart-add'></i>
                </button>
              </div>
            </div>
          </div>
        </div>
      </ng-container>
      <!-- </ng-template> -->

      <!-- <div class="col-lg-2 col-md-3 col-sm-4 col-6 sticky-col ps-0">
  <div class="sticky-wrapper">
    <div class="wp-image text-center mb-2" *ngIf="hasWhatsapp">
      <a [href]="whatsappURL" target="_blank" rel="noopener">
        <img [src]="wpImage" alt="WhatsApp" class="wp-img" />
      </a>
    </div>


<div class="wp-image text-center mb-2 mobile-only" *ngIf="hasSms">
  <a [href]="smsUrl" target="_blank" rel="noopener" title="SMS">
    <img src="assets/img/sms1.png" alt="SMS" class="wp-img" />
  </a>
</div>


    <div class="wp-image text-center mb-2" *ngIf="hasVcard">
      <button class="vcard-only-btn" (click)="downloadVcard()">
        <img [src]="vcard" alt="vCard" class="vcard-small" />
      </button>
    </div>

    <div class="wp-image text-center mb-2" *ngIf="showUpi">
      <button class="upi-btn-small" (click)="openUpi()">
        <span class="upi-text"><b>Pay via</b></span>
        <img [src]="upiImg" alt="UPI" class="upi-small-img" />
      </button>
    </div>

<ng-template #shareDialog let-data="data">
  <div class="share-dialog-content">
    <a target="_blank" rel="noopener" class="facebook-icon"
       (click)="shareOnFacebook(data || social)">
      <i class="fa-brands fa-facebook"></i>
    </a>

    <a class="instagram-icon" (click)="shareOnInstagram(data || social)">
      <i class="fa-brands fa-instagram"></i>
    </a>

    <a class="twitter-icon" (click)="shareOnTwitter(data || social)">
      <i class="bx bxl-twitter"></i>
    </a>

    <a class="linkedin-icon" (click)="shareOnLinkedIn(data || social)">
      <i class="bx bxl-linkedin"></i>
    </a>
  </div>
</ng-template>

  </div>
</div> -->

      <!-- <div class="col-xl-10 col-lg-9 col-md-12"> -->
      <!-- <h3 class="section-title text-center mb-4">Featured</h3> -->
      <!-- // -->

      <!-- <div class="featured-listings pt-4" *ngIf="featuredList?.length > 0">
  <div class="row feature-list-row">
    <div class="col-md-3 col-sm-6 featured-col"
         *ngFor="let item of featuredList">

            <div class="card featured-card pt-5">

              <owl-carousel-o [options]="dealsDetailsImageSlides">
                <ng-template carouselSlide *ngFor="let img of item.productImages">
                  <img class="mt-3" [src]="img?.src" (error)="onImgErr($event)" />
                </ng-template>
              </owl-carousel-o>

              <div class="card-body justify-content-end bt-fix d-flex flex-column text-center">
                <h5 class="card-title mt-auto text-truncate">
                  {{ item.name }}
                </h5>


<div class="row feature-list-row justify-content-center p-0 m-0 pt-1 pb-1 featured-action-row">
  <button type="button"
          (click)="onClickViewDetail(item._id)"
          class="col-lg-8 col-md-8 col-sm-12 mx-1 mb-2 default-custom-btn">
    View
  </button>

                  <button type="button" [ngClass]="item.isWishList
            ? 'col-lg-3 col-md-3 col-sm-3 col-3 default-custom-lock-btn'
            : 'col-lg-3 col-md-3 col-sm-3 col-3 default-custom-btn'" (click)="onClickWishList(item)" class="mb-2">
                    <i class="bx bxs-cart-add"></i>
                  </button>
                </div>

              </div>

            </div>
          </div>
        </div>
      </div>

<div class="pt-4" *ngIf="campaignList.length > 0">
              <div class="row">
                    <div class="col-xl-3 col-lg-6 col-sm-6 col-md-6 deal-container equal-col mb-4 dealContainer"
    
                    *ngFor="let Content of campaignList | paginate: { itemsPerPage: pageSize, currentPage: pageIndex, totalItems: totalRows }">

<div class="ribbon-wrapper sparkle-ribbon" (click)="triggerSparkle($event)">
  <img src="assets/img/onSpecial.png" class="card-overlay-image" />

  <span class="star s1"></span>
  <span class="star s2"></span>
  <span class="star s3"></span>
  <span class="star s4"></span>
  <span class="star s5"></span>
  <span class="star s6"></span>
  <span class="star s7"></span>
  <span class="star s8"></span>
</div>


            <div class="single-deals-box equal-card promotion-card">

                            <owl-carousel-o [options]="dealsDetailsImageSlides">
                                <ng-template carouselSlide *ngFor="let product of getVisibleProducts (Content.products);">
                                    <div class="deals-image mt-3">
                                        <a href="javascript:void(0)" (click)="onClickDetail(Content)">
                                            <img [src]="product.image_url ?? 'assets/img/no-image.png'" alt="image">
                                        </a>
                                    </div>
                                </ng-template>
                            </owl-carousel-o>
      <div class="owl-dots-placeholder"
     *ngIf="(Content.products?.length || 0) <= 1">
 </div>

                            <div class="deals-content">
                                <h3 class="text-center m-0">{{Content.campaignHeading}}</h3>
                                <h3 class="text-center  m-0"><a href="javascript:void(0)"
                                        class="ellipsis">{{Content.campaignName}}</a>
                                </h3>
                                <p class="text-center m-0 ellipsis-description" style="height: 1.8em;width: 100%">
                                    {{Content.offerDescription}}</p>

                <div class="row feature-list-row justify-content-center p-0 m-0 pt-1 pb-1">
                  <button type="button" (click)="onClickClaimNow(Content)"
                    class="col-lg-8 col-md-8 col-sm-12 mx-1 mb-2 default-custom-btn">
                    View </button>
                  <button type="button"
                    [ngClass]="Content.isWishList ? 'col-lg-3 col-md-3 col-sm-3 col-3 default-custom-lock-btn' : 'col-lg-3 col-md-3 col-sm-3 col-3 default-custom-btn'"
                    (click)="onClickWishList(Content)" class="mb-2">
                    <i class='bx bxs-cart-add'></i>
                  </button>
                </div>
              </div>

                        </div>
                    </div>
                    <div class="col-xl-3 col-lg-6 col-sm-6 col-md-6 deal-container" *ngFor="let i of [1,2,3,4,5,6]">
                        <div *ngIf="campaignList.length == 0 && campaignsLoaded == false">                
                            <div class="single-deals-box">
                                <div class="deals-image box-loader">
                                </div>
                                <div class="deals-content">
                                    <h3 class="text-center m-0" class="box-loader" style="height: 1.8em;"></h3>
                                    <h3 class="text-center" class="box-loader" style="height: 1.8em;"></h3>
                                    <p class="text-center m-0" style="height: 1.8em;" class="box-loader"></p>
                                    <span class="location" style="margin-bottom: 12px;"><i class='bx bxs-map'></i>
                                        <p class="box-loader" style="height: 1.8em;"></p>
                                    </span>
                                    <span class="location"><i class='bx bxs-calendar'></i>
                                        <p class="box-loader" style="height: 1.8em;"></p>
                                    </span>
                                    <div class="row feature-list-row justify-content-center pt-3">
                                        <button type="button"
                                            class="col-lg-8 col-md-8 col-sm-8 col-8 mx-1 default-custom-btn">
                                            {{resource.claim_now}}</button>
                                        <button type="button"
                                            [ngClass]="'col-lg-3 col-md-3 col-sm-3 col-3 default-custom-btn'">
                                            <i class='bx bxs-cart-add'></i>
                                        </button>
                                    </div>
                                </div>
                                <div class="box-footer">
                                    <p class="new-price box-loader" style="height: 1.8em;"></p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-xl-12 col-lg-12 col-md-12 no-record"
                        *ngIf="campaignList.length == 0 && campaignsLoaded == true">
                        <div class="row feature-list-row">
                            <div class="text-center mt-3">
                                <h3>{{resource.active_campaign_not_found}}</h3>
                                <p>{{resource.no_record_found_criteria}}</p>
                                <img src="/assets/img/data-not-found.png">
                            </div>
                        </div>
                    </div>

                </div>
</div> -->

      <!-- // -->



      <!-- </div> -->
      <!-- <div class="featured-listings  pt-4" *ngIf="showFeatured && featuredList?.length > 0"> -->
      <!-- <div class="featured-listings  pt-4"   *ngIf="featuredList?.length > 0">

                <div class="row feature-list-row">
                    <div class="col-md-3 col-sm-6 mb-4" *ngFor="let item of featuredList; let i = index">
                        <div class="card h-100">

                            <owl-carousel-o [options]="dealsDetailsImageSlides">
                                <ng-container *ngIf="item?.productImages?.length; else noImg">
                                    <ng-template carouselSlide *ngFor="let img of item.productImages">
                                        <div class="item">
                                            <img class="mt-3" [src]="img?.src" alt="Listing Image"
                                                (error)="onImgErr($event)" />
                                        </div>
                                    </ng-template>
                                </ng-container>
                            </owl-carousel-o>


                            <div class="card-body  justify-content-end bt-fix d-flex flex-column text-center">
                                <h5 class="card-title mb-2 text-truncate mt-auto w-100">{{ item.name}}</h5>
                                <button class="btn btn-danger" (click)="onClickViewDetail(item._id)">View
                                    Details</button>
                            </div>
                        </div>
                    </div>


                </div>


            </div> -->

    </div>
  </div>
  <!-- <div class="col-xl-12 col-lg-12 col-md-12 pt-4" *ngIf="!showFeatured && campaignList.length >0 "> -->

  <!-- <div class="share-dialog-content socialShare" *ngIf="hasAnySocialLinks">
      <ul class="social mt-4">
                    <li *ngIf="social.website">
                      <a [href]="social.website" target="_blank" rel="noopener"><i class="bx bx-globe"></i></a>
                    </li>
                    <li *ngIf="social.facebook">
                      <a [href]="social.facebook" class="facebook" target="_blank" rel="noopener"><i
                          class="bx bxl-facebook"></i></a>
                    </li>
                    <li *ngIf="social.Instagram">
                      <a [href]="social.Instagram" class="instagram" (click)="onShareInstagram()"
                        matTooltip="Copy link, then open Instagram" target="_blank" rel="noopener"><i
                          class="bx bxl-instagram"></i></a>
                    </li>
                    <li *ngIf="social.twitter">
                      <a [href]="social.twitter" class="twitter" target="_blank" rel="noopener"><i
                          class="bx bxl-twitter"></i></a>
                    </li>
                    <li *ngIf="social.tiktok">
                      <a [href]="social.tiktok" class="tiktok" target="_blank" rel="noopener"><i
                          class="bx bxl-tiktok"></i></a>
                    </li>
                    <li *ngIf="social.pinterest">
                      <a [href]="social.pinterest" class="pinterest" target="_blank" rel="noopener"><i
                          class="bx bxl-pinterest"></i></a>
                    </li>
                    <li *ngIf="social.linkedin">
                      <a [href]="social.linkedin" class="linkedin" target="_blank" rel="noopener"><i
                          class="bx bxl-linkedin"></i></a>
                    </li>
                <li *ngIf="social.youTube">
                 <a [href]="social.youTube" class="youtube" target="_blank" rel="noopener">
                 <i class="bx bxl-youtube"></i>
                  </a>
                  </li>

<li>
  <a href="#" title="copy" class="copy" (click)="onCopyClick($event, productOrRow)">
    <i class="bx bx-copy-alt"></i>
  </a>
</li>


                    <li (click)="openShareDialog(shareDialog, $event)"><a title="share" class="share"><img
                          src="assets/img/shareIcon.png" alt="shareImage" class="icon" /></a></li>
                  </ul>
                     </div> -->

  <!-- <ng-template #shareDialog>
                  <div class="share-dialog-content">
                    <a target="_blank" rel="noopener" class="facebook-icon" (click)="shareOnFacebook(item)">
                      <i class="fab fa-facebook"></i>view
                    </a>
                    <a class="instagram-icon" (click)="shareOnInstagram(item)">
                      <i class="fab fa-instagram"></i>
                    </a>
                    <a class="twitter-icon" (click)="shareOnTwitter(item)"> <i class="bx bxl-twitter"></i></a>
                    <a class="linkedin-icon" (click)="shareOnLinkedIn(item)"><i class="bx bxl-linkedin"></i></a>
                  </div>
                </ng-template> -->
</div>
<!-- </div>

</div> -->